enum ActionTypes {
  FETCH_PROVINCE_REQUEST = 'app/Address/FETCH_PROVINCE_REQUEST',
  FETCH_PROVINCE_SUCCESS = 'app/Address/FETCH_PROVINCE_SUCCESS',
  FETCH_PROVINCE_FAILURE = 'app/Address/FETCH_PROVINCE_FAILURE',
  FETCH_DISTRICT_REQUEST = 'app/Address/FETCH_DISTRICT_REQUEST',
  FETCH_DISTRICT_SUCCESS = 'app/Address/FETCH_DISTRICT_SUCCESS',
  FETCH_DISTRICT_FAILURE = 'app/Address/FETCH_DISTRICT_FAILURE',
  FETCH_WARDS_REQUEST = 'app/Address/FETCH_WARDS_REQUEST',
  FETCH_WARDS_SUCCESS = 'app/Address/FETCH_WARDS_SUCCESS',
  FETCH_WARDS_FAILURE = 'app/Address/FETCH_WARDS_FAILURE',
  GET_DISTRICT_BY_PROVINCE = 'app/Address/GET_DISTRICT_BY_PROVINCE',
  GET_WARDS_BY_DISTRICT = 'app/Address/GET_WARDS_BY_DISTRICT',
}
export default ActionTypes;
